import { type ModalOptions, useModalStore } from '@/core/stores/modal.ts'
import type { Component } from 'vue'

let modalStore: ReturnType<typeof useModalStore> | null = null

export const initModalService = () => {
  modalStore = useModalStore()
}

export const openModal = <T = any>(
  component: Component,
  options: ModalOptions = {},
  props: Record<string, any> = {},
): Promise<T> => {
  if (!modalStore) {
    throw new Error('Modal service not initialized. Call initModalService() first.')
  }

  return modalStore.openModal<T>(component, options, props)
}

export const closeModal = (id: string, result?: any) => {
  if (!modalStore) {
    throw new Error('Modal service not initialized.')
  }

  modalStore.closeModal(id, result)
}

export const dismissModal = (id: string, reason?: any) => {
  if (!modalStore) {
    throw new Error('Modal service not initialized.')
  }

  modalStore.dismissModal(id, reason)
}

export const closeAllModals = () => {
  if (!modalStore) {
    throw new Error('Modal service not initialized.')
  }

  modalStore.closeAllModals()
}
